import styles from "./PEGI.module.css"
type PEGIProps = {
    pegi: number,
    size?: PEGISize
}

export enum PEGISize {
    MEDIUM,
    SMALL
}

export default function PEGI({ pegi, size = PEGISize.MEDIUM }: PEGIProps) {

    let group = 'child'

    switch(pegi) {
        case 3:
        case 7:
            group = 'child';
            break;
        case 12:
        case 16:
            group = 'teen'
            break
        case 18:
            group = 'adult'
            break
    }
    return (
        <div data-testid="PEGI" className={`${styles[group]} ${styles.pegi} ${size === PEGISize.MEDIUM ? styles.medium : styles.small}`}>
            {pegi}
        </div>
    )
}